import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-qa": "card_getting_error" } },
    [
      _c(VImg, {
        staticClass: "mx-auto mb-2",
        attrs: {
          width: "72",
          height: "72",
          "data-qa": "card_getting_error_icon",
          src: "/static/_v1/pd/icons/ui-kit/club/club-check-close.svg",
          alt: "Иконка ошибки",
        },
      }),
      _vm._v(" "),
      _vm.componentData.title
        ? _c(
            "div",
            {
              staticClass: "text-h5 text--text mb-2 text-center",
              attrs: { "data-qa": "card_getting_error_title" },
            },
            [_vm._v("\n    " + _vm._s(_vm.componentData.title) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.componentData.message
        ? _c(
            "div",
            {
              staticClass: "text-body-1 text-secondary--text text-center",
              attrs: { "data-qa": "card_getting_error_message" },
            },
            [_vm._v("\n    " + _vm._s(_vm.componentData.message) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.buttonSubmit || _vm.buttonCancel
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _vm.buttonSubmit
                ? _c(
                    VBtn,
                    {
                      staticClass: "mt-2",
                      attrs: {
                        block: "",
                        color: "primary",
                        elevation: "0",
                        "data-qa": "card_getting_error_btn_submit",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit(
                            _vm.events.club.cardGettingErrorSubmit,
                            _vm.buttonSubmit.action
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.buttonSubmit.text) + "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.buttonCancel
                ? _c(
                    VBtn,
                    {
                      staticClass: "mt-2",
                      attrs: {
                        text: "",
                        block: "",
                        color: "text",
                        elevation: "0",
                        "data-qa": "card_getting_error_btn_cancel",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit(
                            _vm.events.club.cardGettingErrorCancel,
                            _vm.buttonCancel.action
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.buttonCancel.text) + "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }